import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-loading-spinner',
    templateUrl: 'loading-spinner.html'
})
export class LoadingSpinnerComponent {
    @Input() show = true
    @Input() label = 'Loading'
    @Input() positionAbsolute = false
    @Input() inline = false
    @Input() small = false
    @Input() modifierClasses: string
}
